import { render, staticRenderFns } from "./curriculumManagement.vue?vue&type=template&id=e4368c9a&scoped=true"
import script from "./curriculumManagement.vue?vue&type=script&lang=js"
export * from "./curriculumManagement.vue?vue&type=script&lang=js"
import style0 from "./curriculumManagement.vue?vue&type=style&index=0&id=e4368c9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4368c9a",
  null
  
)

export default component.exports